module.exports = __webpack_public_path__ + "static/dan-black-3d932de6a62226a2da2d1248511fdaf0.jpg";